import { useSelector } from 'react-redux';
import styled from 'styled-components';

import ControlsInfo from 'modules/common/viewer/cadViewer/addOns/ControlsInfo';
import DimensionTool from 'modules/common/viewer/cadViewer/addOns/DimensionTool';
import ExplodedViewSlider from 'modules/common/viewer/cadViewer/addOns/ExplodedViewSlider';
import ExplodedViewTool from 'modules/common/viewer/cadViewer/addOns/ExplodedViewTool';
import FocusedViewTool from 'modules/common/viewer/cadViewer/addOns/FocusedViewTool';
import HighlightViewTool from 'modules/common/viewer/cadViewer/addOns/HighlightViewTool';
import MeasurementTool from 'modules/common/viewer/cadViewer/addOns/MeasurementTool';
import OptimalBoundingBoxTool from 'modules/common/viewer/cadViewer/addOns/OptimalBoundingBoxTool';
import PMIViewTool from 'modules/common/viewer/cadViewer/addOns/PMIViewTool';
import ResetViewTool from 'modules/common/viewer/cadViewer/addOns/ResetViewTool';
import SelectorTool from 'modules/common/viewer/cadViewer/addOns/SelectorTool';
import WireFrameTool from 'modules/common/viewer/cadViewer/addOns/WireFrameTool';
import DisplayOptionsPopover from 'modules/common/viewer/cadViewer/components/DisplayOptionsPopover';
import {
  getDoesActiveFileHaveOptimalBoundingBox,
  getIsActiveFile3DRenderable,
  getIsActiveFileAssembly,
} from 'modules/common/viewer/data/reducer';

import { useFeatureFlagValue } from 'store/session/hooks';

import { featureFlagKeys } from '../drawers/featureFlagDrawer/const/featureFlagKeys';

const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 10px;
`;

const CenterButtonsContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  flex-grow: 1;
  justify-content: center;
  flex-wrap: wrap;

  button {
    border-radius: 4px;
    cursor: pointer;
    height: 32px;
    outline: none;
    transition: 0.2s ease all;
    width: 32px;

    :active {
      background: #268af5;
      margin-top: 1px;
    }
  }
`;

const VerticalCenterButtonsContainer = styled.div`
  flex-direction: column;
`;

const ExplodeSliderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  left: 0;
  margin-left: auto;
  margin-right: auto;
  width: 200px;
  position: absolute;
  right: 0;
  z-index: 2;
`;

const CADViewerTools = () => {
  const doesActiveFileHaveOptimalBoundingBox = useSelector(
    getDoesActiveFileHaveOptimalBoundingBox,
  );
  const isEnabled = useSelector(getIsActiveFile3DRenderable);
  const isActiveFileAssembly = useSelector(getIsActiveFileAssembly);

  const isPMIEnabled = useFeatureFlagValue(
    featureFlagKeys.isPmiRenderingEnabled,
  );

  return (
    <>
      <VerticalCenterButtonsContainer>
        <ButtonsContainer>
          <CenterButtonsContainer>
            <SelectorTool isEnabled={isEnabled} />
            <MeasurementTool isEnabled={isEnabled} />
            <DimensionTool isEnabled={isEnabled} />
            <OptimalBoundingBoxTool
              isEnabled={isEnabled && doesActiveFileHaveOptimalBoundingBox}
            />
            <PMIViewTool isEnabled={isEnabled && isPMIEnabled} />
            <WireFrameTool isEnabled={isEnabled} />
            <HighlightViewTool isEnabled={isEnabled} />
            <FocusedViewTool isEnabled={isEnabled} />
            <ResetViewTool isEnabled={isEnabled} />
            <ExplodedViewTool isEnabled={isEnabled && isActiveFileAssembly} />
            {isEnabled && <ControlsInfo />}
          </CenterButtonsContainer>
          {isEnabled && <DisplayOptionsPopover />}
        </ButtonsContainer>
        <ExplodeSliderContainer>
          <ExplodedViewSlider isEnabled={isEnabled && isActiveFileAssembly} />
        </ExplodeSliderContainer>
      </VerticalCenterButtonsContainer>
    </>
  );
};

export default CADViewerTools;
